import * as React from 'react';
import { Translate } from '../../shared/LanguageService';
import { Modal, Button, Checkbox } from 'react-bootstrap';

interface IConfirmationModalProps {
    title: string;
    text: string | React.ReactElement;
    doButtonLabel: string;
    cancelButtonLabel: string;
    doButtonStyle: string;
    noAction?: () => void;
    do: () => void;
    closeModal: () => void;
    middleButtonLabel?: string;
    middleButtonStyle?: string;
    middleButtonOnClick?: () => void;
    extraValidation?: boolean;
    extraValidationText?: string;
    disableSubmit?: boolean;
    initialSubmitDisabling?: boolean;
    onCheckboxToggle?: (e: any) => void;
    size?: any;
    dialogClassName?: string;
    showDialog?: boolean;
    backdrop?: boolean | 'static';
}

const ConfirmationModal = (props: IConfirmationModalProps) => {
    return (
        <Modal
            show={props.showDialog !== undefined ? props.showDialog : true}
            onHide={() => {
                if (props.noAction) {
                    props.noAction();
                }
                props.closeModal();
            }}
            style={{ zIndex: 2000 }}
            backdrop={props.backdrop !== undefined ? props.backdrop : true}
            backdropStyle={{ zIndex: 1990 }}
            bsSize={props.size ? props.size : 'small'}
            onKeyPress={(target) => {
                if (target.charCode === 13) {
                    props.do();
                    props.closeModal();
                }
            }}
            dialogClassName={props.dialogClassName}
        >
            <Modal.Header closeButton>
                <Modal.Title>{props.title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>{props.text}</Modal.Body>
            <Modal.Footer>
                {props.extraValidation && (
                    <Checkbox checked={!props.disableSubmit} onChange={props.onCheckboxToggle}>
                        <span>{Translate(props.extraValidationText)}</span>
                    </Checkbox>
                )}
                <Button
                    onClick={() => {
                        props.do();
                        props.closeModal();
                    }}
                    bsStyle={props.doButtonStyle}
                    disabled={props.disableSubmit && props.initialSubmitDisabling}
                >
                    {props.doButtonLabel}
                </Button>

                {props.middleButtonLabel && props.middleButtonOnClick && (
                    <Button onClick={props.middleButtonOnClick} bsStyle={props.middleButtonStyle}>
                        {props.middleButtonLabel}
                    </Button>
                )}

                <Button
                    onClick={() => {
                        if (props.noAction) {
                            props.noAction();
                        }
                        props.closeModal();
                    }}
                >
                    {props.cancelButtonLabel}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ConfirmationModal;
